export default {
  locale: 'en-us',
};
